var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 27,
    viewBox: "0 0 39 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.911 4.22459C37.474 2.5617 36.1864 1.25205 34.5514 0.807609C31.588 0 19.7051 0 19.7051 0C19.7051 0 7.82221 0 4.85873 0.807609C3.2238 1.25213 1.93616 2.5617 1.49912 4.22459C0.705078 7.23867 0.705078 13.5273 0.705078 13.5273C0.705078 13.5273 0.705078 19.8159 1.49912 22.83C1.93616 24.4929 3.2238 25.7479 4.85873 26.1924C7.82221 27 19.7051 27 19.7051 27C19.7051 27 31.5879 27 34.5514 26.1924C36.1864 25.7479 37.474 24.4929 37.911 22.83C38.7051 19.8159 38.7051 13.5273 38.7051 13.5273C38.7051 13.5273 38.7051 7.23867 37.911 4.22459ZM15.8187 19.2369V7.8177L25.7505 13.5274L15.8187 19.2369Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeWhite);
export default __webpack_public_path__ + "static/media/youtube-white.5a52d5dfa3739076d344d9815a24fb45.svg";
export { ForwardRef as ReactComponent };